import * as Yup from "yup";

export type FormErrorType = Record<string, string>;

export const STANDARD_SUBMIT_ERROR =
  "There was an error with your submission. If you continue experiencing issues, please contact ZEOS.";

export const COMPLETED_FORM_STORAGE_KEY = "completedFormIds";

// export const validateForm = async <TFormData>(
//   schema: Yup.ObjectSchema<any>,
//   formData: TFormData,
//   successCallback: () => void,
//   errCallback: (fieldErrors: Record<string, string>) => void
// ) => {
//   try {
//     await schema.validate(formData, { abortEarly: false });
//     successCallback();
//   } catch (err: unknown) {
//     if (err instanceof Yup.ValidationError) {
//       const fieldErrors: Record<string, string> = {};
//       err.inner.forEach((e) => {
//         if (e.path) fieldErrors[e.path] = e.message;
//       });
//       errCallback(fieldErrors);
//     }
//   }
// };
